import { WidgetBase, IWidgetConfiguration } from '../';
import { Helper } from '../../common';

export class PercentageEvolutionWidgetBase extends WidgetBase {
    baseType = 'percentageEvolution';
    col = 0;
    guid: string;
    icon = 'fa-line-chart';
    isExportable = true;
    isZoomable = true;
    row = 0;
    sizeX = 6;
    sizeY = 18;

    constructor(config?: IWidgetConfiguration) {
        super();
        this.setConfiguration(config);
        this.guid = Helper.getGuid();
    }
}